import React from 'react';

import { Modal } from '@zapier/design-system';

import { ROLES } from 'app/developer-v3/constants';
import PartnerProfileForm, {
  PartnerProfileFormValues,
  Role,
} from 'app/developer-v3/components/PartnerProfileForm';

type Props = {
  appImage: string;
  appTitle: string;
  errorMessages: Array<string>;
  firstName: string;
  invitationType: ROLES.admin | ROLES.collaborator;
  isSaving: boolean;
  jobTitle: string;
  lastName: string;
  roles: Array<Role>;
  submitInviteModal: (invitationData: PartnerProfileFormValues) => void;
  termsAccepted: boolean;
};

function Invite({
  appImage,
  appTitle,
  errorMessages,
  firstName,
  invitationType,
  isSaving,
  jobTitle,
  lastName,
  roles,
  submitInviteModal,
  termsAccepted,
}: Props) {
  return (
    <Modal canClose={false} onClosed={() => undefined}>
      <PartnerProfileForm
        appImage={appImage}
        appTitle={appTitle}
        errorMessages={errorMessages}
        firstName={firstName}
        formTitle={`You’re invited to help manage ${appTitle}'s Zapier integration`}
        invitationType={invitationType}
        isHeroImageVisible={true}
        isSaving={isSaving}
        jobTitle={jobTitle}
        lastName={lastName}
        onConfirm={submitInviteModal}
        roles={roles}
        sections={['roles', 'title', 'opt-in', 'tos']}
        submitText="Accept and view my integration"
        termsAccepted={termsAccepted}
      />
    </Modal>
  );
}

export default Invite;
